import httpClient from 'http-client';
import Author from './models/author-interface';

interface IAuthorResponse {
  authors: Author[];
  specialty: Array<string>;
}

const getAllAuthors = async (
  filters?: object,
  headers?: object,
): Promise<IAuthorResponse> => {
  const response = await httpClient.get<IAuthorResponse>('/authors', {
    params: filters,
    headers,
  });

  // ordem desejada
  const order = [
    "Dra. Camille Rocha Risegato",
    "Dra. Vania Carolina Stancka ",
    "Dra. Mariana Rosário",
    "Dra. Fernanda Misumi",
    "Dra. Natalie Haddad",
    "Flávia Rodrigues",
    "Cintia Fiori",
    "Thalita Freitas & Alessandra Sônego",
    "Veronica Pires ",
    "Priscila Goldenberg",
    "Marília Brasil",
    "Luciana Garcia",
    "Juliana Faria",
    "Xenya Bucchioni "
  ];

  // supondo que apiResponse seja o objeto que você mostrou
  const sortedAuthors = [...response.data.authors].sort((a, b) => {
    const indexA = order.indexOf(a.name);
    const indexB = order.indexOf(b.name);
    return indexA - indexB;
  });

  // return (response || { data: {} }).data;
  return  {
    specialty: response?.data?.specialty || [],
    authors: sortedAuthors
  };
};

const getAuthor = async (author_id: string): Promise<Author> => {
  const author: Author = (await httpClient.get(`/authors/${author_id}`)).data;

  return author;
};

export { getAllAuthors, getAuthor };